import { render, staticRenderFns } from "./SupportPage.vue?vue&type=template&id=4c92e33d&"
import script from "./SupportPage.vue?vue&type=script&lang=ts&"
export * from "./SupportPage.vue?vue&type=script&lang=ts&"
import style0 from "./SupportPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports